import { useLang } from "../../lib/i18n";

const Bar = ({ label, value, max, testId }) => (
  <li data-testid={testId}>
    <div className="flex items-center justify-between text-sm">
      <span className="font-medium text-slate-700">{label}</span>
      <span className="font-mono text-slate-900">{value}</span>
    </div>
    <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-slate-100">
      <div className="h-full rounded-full bg-slate-900 transition-[width] duration-500" style={{ width: `${max ? (value / max) * 100 : 0}%` }} />
    </div>
  </li>
);

export const TopLinks = ({ links }) => {
  const { t, lang } = useLang();
  const max = Math.max(0, ...links.map((l) => l.count));
  return (
    <div className="rounded-3xl border border-slate-200/80 bg-white p-5" data-testid="insights-top-links">
      <p className="mb-4 font-display text-base font-bold text-slate-900">{t("ins_top_links")}</p>
      {links.length === 0 ? <p className="text-sm text-slate-400">{t("ins_none")}</p> : (
        <ul className="space-y-3">
          {links.map((l) => <Bar key={l.key} label={lang === "ar" ? l.label_ar : l.label_en} value={l.count} max={max} testId={`insights-link-${l.key}`} />)}
        </ul>
      )}
    </div>
  );
};

export const Devices = ({ devices }) => {
  const { t } = useLang();
  const max = Math.max(devices.mobile, devices.desktop);
  return (
    <div className="rounded-3xl border border-slate-200/80 bg-white p-5" data-testid="insights-devices">
      <p className="mb-4 font-display text-base font-bold text-slate-900">{t("ins_devices")}</p>
      <ul className="space-y-3">
        <Bar label={t("ins_mobile")} value={devices.mobile} max={max} testId="insights-device-mobile" />
        <Bar label={t("ins_desktop")} value={devices.desktop} max={max} testId="insights-device-desktop" />
      </ul>
    </div>
  );
};
